import { SvgIcon, type SvgIconProps } from '@mui/material';

export const GuidedTourIcon = (props: SvgIconProps) => (
    <SvgIcon
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M18 13.5L14.4159 8.69858C13.8175 7.90642 13.5 6.97207 13.5 6C13.5 3.51877 15.5185 1.5 18 1.5C20.4815 1.5 22.5 3.51877 22.5 6C22.5 6.97207 22.1825 7.9065 21.5816 8.7021L18 13.5ZM18 3C16.3458 3 15 4.3458 15 6C15 6.64327 15.2128 7.26487 15.6152 7.7979L18 10.9925L20.3822 7.80135C20.7872 7.26487 21 6.6432 21 5.99992C21 4.34572 19.6542 3 18 3Z"
            fill="currentColor"
        />
        <path
            d="M18 7.5C18.8284 7.5 19.5 6.82843 19.5 6C19.5 5.17157 18.8284 4.5 18 4.5C17.1716 4.5 16.5 5.17157 16.5 6C16.5 6.82843 17.1716 7.5 18 7.5Z"
            fill="currentColor"
        />
        <path
            d="M21 13.5V16.5H3V4.5H10.5V3H3C2.17162 3 1.5 3.67162 1.5 4.5V16.5C1.5 17.3284 2.17162 18 3 18H9V21H6V22.5H18V21H15V18H21C21.8284 18 22.5 17.3284 22.5 16.5V13.5H21ZM13.5 21H10.5V18H13.5V21Z"
            fill="currentColor"
        />
    </SvgIcon>
);
